import { FaPen ,FaTrashAlt } from 'react-icons/fa';

export const partnerColumns = (openModal, clickDelete, openFileModal) => [
  { header: '등록일', accessor: 'registrationDt' },
  { header: '거래처명', accessor: 'partnerName' },
  { header: '대표자명', accessor: 'bossName' },
  { header: '사업자등록번호', accessor: 'brNumber' },
  { header: '회사 이메일', accessor: 'partnerEmail' },
  { header: '지역', accessor: 'location' },
  { header: '주소', accessor: 'address' },
  { header: '대표번호', accessor: 'phoneNumber' },
  { header: 'FAX', accessor: 'faxNumber' },
  // { header: '상세보기', accessor: 'details', render: (row) => (
  //   <TableButton text="상세보기" onClick={() => handleCustomerClick(row)} className="detail-view"/>
  // )},
  { header: '첨부파일', accessor: 'attachments', render: (row) => <span onClick={(e) => {e.stopPropagation(); openFileModal(row)}}>📎</span> },
  { header: '수정',accessor: 'update', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); openModal(2, 1, row)}} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); clickDelete(row, 1)}} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];
export const partnerFormFields = [
  { key: "partnerSeq", label: "협력사번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "registrationDt", label: "등록일", type: "date", size: 6, visible: true, required: false },
  { key: "partnerName", label: "업체명", type: "text", size: 6, visible: true, required: true },
  { key: "bossName", label: "대표자", type: "text", size: 6, visible: true, required: true },
  { key: "brNumber", label: "사업자 등록번호", type: "text", size: 6, visible: true, required: false, format: "bizNo" },
  { key: "partnerEmail", label: "이메일", type: "text", size: 6, visible: true, required: false, format: "email" },
  { key: "location", label: "지역", type: "text", size: 6, visible: true, required: false },
  { key: "address", label: "주소", type: "text", size: 6, visible: true, required: false },
  { key: "phoneNumber", label: "연락처", type: "text", size: 6, visible: true, required: true, format: "phone" },
  { key: "faxNumber", label: "팩스번호", type: "text", size: 6, visible: true, required: false },
]

export const managerColumns = (openModal, clickDelete) => [
  { header: '담당자명', accessor: 'userName' },
  { header: '직급', accessor: 'rank' },
  { header: '연락처', accessor: 'phoneNum' },
  { header: '이메일', accessor: 'email' },
  //{ header: '비고', accessor: 'note' },
  { header: '수정',accessor: 'update', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); openModal(2, 2, row)}} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); clickDelete(row, 2)}} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];
export const managerFormFields = [
  { key: "partnerManagerSeq", label: "협력사번호", type: "text", size: 6, visible: false, required: false },
  { key: "partnerSeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: "user", labelKey: "userName", valueKey: "userSeq", visible: true, required: true },
]
export const statusColumns = [
  { header: '항목', accessor: 'label' },
  { header: '건수', accessor: 'value' },
];